import { NavLink, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuth';
import { useTheme } from '../contexts/ThemeContext';

const links = [
  { to: '/',          label: 'Vehicles' },
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/kanban',    label: 'Kanban' },
  { to: '/handling',  label: 'Handling' },
  { to: '/changes',   label: 'Changes' },
  { to: '/tags',      label: 'Tags' },
];

export default function Nav() {
  const { user, logout } = useAuthContext();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-dark text-white font-body z-40 relative">
      <div className="flex items-center justify-between px-6 h-14">
        {/* Logo */}
        <div className="flex items-center gap-3">
          {/* Rising sun motif */}
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
            <circle cx="14" cy="14" r="5" fill="#C8102E"/>
            {[0,30,60,90,120,150,180,210,240,270,300,330].map(deg => (
              <line
                key={deg}
                x1={14 + 7 * Math.cos(deg * Math.PI / 180)}
                y1={14 + 7 * Math.sin(deg * Math.PI / 180)}
                x2={14 + 12 * Math.cos(deg * Math.PI / 180)}
                y2={14 + 12 * Math.sin(deg * Math.PI / 180)}
                stroke="#C8102E"
                strokeWidth="1.5"
              />
            ))}
          </svg>
          <span className="font-heading text-xl tracking-widest font-bold">Sakura</span>
          <span className="text-white/30 text-xs hidden sm:block tracking-wide">VEHICLE MANAGER</span>
        </div>

        {/* Nav links */}
        <div className="flex items-center gap-1">
          {links.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `px-4 py-1.5 font-heading uppercase text-sm tracking-wide transition-colors ${
                  isActive ? 'text-primary' : 'text-white hover:text-primary'
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        {/* User + theme toggle + logout */}
        <div className="flex items-center gap-3">
          {user && (
            <span className="text-white/40 text-xs font-body hidden sm:block">
              {user.username}
            </span>
          )}

          {/* Dark mode toggle */}
          <button
            onClick={toggle}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            className="w-8 h-8 flex items-center justify-center border border-white/20 hover:border-primary hover:text-primary transition-colors"
            style={{ fontSize: 15 }}
          >
            {theme === 'dark' ? '☀' : '🌙'}
          </button>

          <button
            onClick={handleLogout}
            className="px-3 py-1 text-xs font-heading uppercase border border-white/20 text-white hover:text-primary hover:border-primary transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
      {/* Red accent line */}
      <div className="h-px bg-primary" />
    </nav>
  );
}
